import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import BrandModal from '../components/BrandModal';

export default function Home() {
  const [brands, setBrands] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  const load = () => {
    api.listBrands().then(setBrands).catch(() => setBrands([]));
  };

  useEffect(load, []);

  const onCreated = (brand) => {
    setModalOpen(false);
    navigate(`/lead-quality-score/brands/${brand.id}`);
  };

  if (brands === null) return null;

  return (
    <div className="container page-content">
      <div className="page-header">
        <div className="page-header-top">
          <div>
            <div className="hero-eyebrow">Rush Republic / Internal Tool</div>
            <h1 className="hero-title">Lead Quality<br />Score</h1>
            <p className="hero-subtext">Measure the quality of every lead generated through Meta Ads and Google Ads.</p>
          </div>
          <div className="page-header-actions">
            <button className="btn btn-primary btn-sm" onClick={() => setModalOpen(true)}>+ Add Brand</button>
          </div>
        </div>
      </div>

      {brands.length === 0 ? (
        <div className="empty-state">
          <h3>No Brands Yet</h3>
          <p>Create your first brand to start analysing lead quality.</p>
          <button className="btn btn-primary mt-8" onClick={() => setModalOpen(true)}>+ Add Brand</button>
        </div>
      ) : (
        <div className="brands-grid">
          {brands.map((brand) => (
            <BrandCard key={brand.id} brand={brand} onClick={() => navigate(`/lead-quality-score/brands/${brand.id}`)} />
          ))}
        </div>
      )}

      <BrandModal open={modalOpen} onClose={() => setModalOpen(false)} onCreated={onCreated} />
    </div>
  );
}

function BrandCard({ brand, onClick }) {
  return (
    <div className="brand-card" onClick={onClick}>
      <div>
        <div className="brand-card-name" style={{ marginTop: 0, marginBottom: 4 }}>{brand.brand_name}</div>
        <span className="brand-card-eyebrow">{brand.industry}</span>
      </div>
    </div>
  );
}
